export function createRouterGuards(router) {
  router.beforeEach(async (to, from, next) => {
    const Loading = window.$loading || null
    Loading && Loading.start()
    next()
  })
  router.afterEach((to, _, failure) => {
    const Loading = window.$loading || null
    Loading && Loading.finish()
  })
  router.onError((error) => {
    console.log(error, '路由错误')
  })
}
